/**
 * UpgradeModal — reusable plan upgrade prompt.
 * Shown when a user clicks a feature locked on their current plan.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UpgradeModalProps {
  featureName: string;
  featureDescription: string;
  requiredPlan: string;
  onClose: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  featureName,
  featureDescription,
  requiredPlan,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        background: 'rgba(0,0,0,0.52)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: 18, padding: '40px 36px', maxWidth: 460, width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
          animation: 'upgfadeIn 0.18s ease both',
        }}
        onClick={e => e.stopPropagation()}
      >
        <style>{`@keyframes upgfadeIn{from{opacity:0;transform:scale(0.95)}to{opacity:1;transform:scale(1)}}`}</style>

        {/* Icon */}
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 64, height: 64, borderRadius: '50%',
            background: '#eff6ff', fontSize: 32, marginBottom: 14,
          }}>🔒</div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#111827', lineHeight: 1.2 }}>
            {featureName}
          </h2>
        </div>

        {/* Description */}
        <p style={{ fontSize: 15, color: '#4b5563', lineHeight: 1.65, textAlign: 'center', margin: '0 0 16px' }}>
          {featureDescription}
        </p>

        {/* Plan label */}
        <div style={{
          background: '#eff6ff', border: '1.5px solid #bfdbfe', borderRadius: 10,
          padding: '11px 18px', textAlign: 'center', marginBottom: 28,
          fontSize: 14, fontWeight: 700, color: '#1d4ed8',
        }}>
          This feature is available on <strong>{requiredPlan}</strong>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1, padding: '13px 0', borderRadius: 10, border: '1.5px solid #e5e7eb',
              background: '#fff', color: '#374151', fontWeight: 600, fontSize: 14,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Maybe Later
          </button>
          <button
            onClick={() => { onClose(); navigate('/business-registration'); }}
            style={{
              flex: 2, padding: '13px 0', borderRadius: 10, border: 'none',
              background: '#1e3a8a', color: '#fff', fontWeight: 800, fontSize: 15,
              cursor: 'pointer', fontFamily: 'inherit',
              boxShadow: '0 4px 14px rgba(30,58,138,0.35)',
            }}
          >
            Upgrade Now →
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
